// for moment.js
// de for german
// en-gb for UK (same as en for USA, but removes AM/PM and uses 24-hour format)

import store from "@src/reducers/store";
import { Language } from "@src/reducers/your-reducer";

export const getLanguage = (): Language => {
  const language = store.getState().yourSlice.language;
  return language ? language : "en";
};
